module.exports = __webpack_public_path__ + "img/verify-icon.7ea5ad6a.svg";